export default __webpack_public_path__ + "static/media/allTakenCourse.16284274.svg";